import { jsx as _jsx } from "react/jsx-runtime";
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import ZapierLogo from './ZapierLogo';
export default function ZapierCard() {
    const { t: zapierTexts } = useLocaleKeys('integrations.availableApps.zapier');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('zapier');
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "zapier-card",
        icon: /*#__PURE__*/ _jsx(ZapierLogo, {}),
        title: zapierTexts.title(),
        subTitle: zapierTexts.subtitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_zapier'
            },
            onClick: showCopyAPIKeyModal,
            testId: "zapier-card-connect",
            children: sharedTexts.connectButton()
        })
    });
}
